import * as types from '../types/authTypes';
import { USE_API } from '../../config/env';
import { authService } from '../../services/authService';
import { persistAuth } from '../reducers/authReducer';

export const logout = () => (dispatch) => {
  persistAuth(null, null);
  dispatch({ type: types.LOGOUT });
};

export const clearAuthError = () => ({ type: types.CLEAR_AUTH_ERROR });

export const loginThunk =
  ({ email, password }) =>
  async (dispatch) => {
    if (!USE_API) return { success: false, error: 'API disabled' };
    dispatch({ type: types.LOGIN_REQUEST });
    try {
      const data = await authService.login(email, password);
      const user = data?.user ?? null;
      const token = data?.token ?? null;
      if (!token) {
        const err = 'No token returned';
        dispatch({ type: types.LOGIN_FAILURE, payload: err });
        return { success: false, error: err };
      }
      persistAuth(token, user);
      dispatch({ type: types.LOGIN_SUCCESS, payload: { user, token } });
      return { success: true, user };
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || 'Login failed';
      dispatch({
        type: types.LOGIN_FAILURE,
        payload: msg,
      });
      return { success: false, error: msg };
    }
  };

export const registerThunk =
  ({ email, password, firstName, lastName, phone }) =>
  async (dispatch) => {
    if (!USE_API) return { success: false, error: 'API disabled' };
    dispatch({ type: types.REGISTER_REQUEST });
    try {
      const data = await authService.register({ email, password, firstName, lastName, phone });
      const user = data?.user ?? null;
      const token = data?.token ?? null;
      if (!token) {
        const err = 'No token returned';
        dispatch({ type: types.REGISTER_FAILURE, payload: err });
        return { success: false, error: err };
      }
      persistAuth(token, user);
      dispatch({ type: types.REGISTER_SUCCESS, payload: { user, token } });
      return { success: true, user };
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || 'Registration failed';
      dispatch({
        type: types.REGISTER_FAILURE,
        payload: msg,
      });
      return { success: false, error: msg };
    }
  };

export const fetchAuthMe = () => async (dispatch, getState) => {
  if (!USE_API) return;
  if (!getState().auth?.token) return;
  dispatch({ type: types.FETCH_AUTH_ME_REQUEST });
  try {
    const user = await authService.getMe();
    if (user) {
      persistAuth(getState().auth.token, user);
      dispatch({ type: types.FETCH_AUTH_ME_SUCCESS, payload: user });
    } else {
      dispatch({ type: types.FETCH_AUTH_ME_SUCCESS, payload: null });
    }
  } catch (e) {
    persistAuth(null, null);
    dispatch({ type: types.FETCH_AUTH_ME_FAILURE, payload: e?.message || 'Session expired' });
  }
};

export function selectAuthToken(state) {
  return state.auth?.token ?? null;
}

export function selectAuthUser(state) {
  return state.auth?.user ?? null;
}

export function selectAuthReady(state) {
  return !!state.auth?.token;
}
